<template>
  <!-- <div class="license_box">
    <table class="table table-bordered">
      <tbody>
      <template v-for="(item, index) in items">
        <tr>
          <td><label>{{item.itemKey}}</label></td>
        </tr>
        <tr>
          <td>{{item.itemValue}}</td>
        </tr>
      </template>
      </tbody>
    </table>
  </div> -->
  <div>
    <div class="row h-row-inputBox" v-if="!imsFlag">
      <div class="col-sm-6 h-col-inputBox">
        <div class="form-group">
          <div class="e-float-input">
            <div class="h-inputLit">{{$t('Security.Lic.sn')}}:</div>
            <input class="e-input e-input-group" v-model="sn" readonly />
          </div>
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div class="form-group">
          <div class="e-float-input">
            <div class="h-inputLit">{{$t('Security.Lic.slice')}}:</div>
            <input class="e-input e-input-group" v-model="slice" readonly />
          </div>
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div class="form-group">
          <div class="e-float-input">
            <div class="h-inputLit">{{$t('Security.Lic.throughPut')}}:</div>
            <input class="e-input e-input-group" v-model="throughPut" readonly />
          </div>
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div class="form-group">
          <div class="e-float-input">
            <div class="h-inputLit">{{$t('Security.Lic.maxNumberOfUe')}}:</div>
            <input class="e-input e-input-group" v-model="maxNumberOfUe" readonly />
          </div>
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div class="form-group">
          <div class="e-float-input">
            <div class="h-inputLit">{{$t('Security.Lic.numberOfStation')}}:</div>
            <input class="e-input e-input-group" v-model="numberOfStation" readonly />
          </div>
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div class="form-group">
          <div class="e-float-input">
            <div class="h-inputLit">{{$t('Security.Lic.caps')}}:</div>
            <input class="e-input e-input-group" v-model="caps" readonly />
          </div>
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox" v-if="imsFlag">
      <div class="col-sm-6 h-col-inputBox">
        <div class="form-group">
          <div class="e-float-input">
            <div class="h-inputLit">{{$t('Security.Lic.sn')}}:</div>
            <input class="e-input e-input-group" v-model="sn" readonly />
          </div>
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div class="form-group">
          <div class="e-float-input">
            <div class="h-inputLit">{{$t('Security.Lic.maxNumberOfUe')}}:</div>
            <input class="e-input e-input-group" v-model="maxNumberOfUe" readonly />
          </div>
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div class="form-group">
          <div class="e-float-input">
            <div class="h-inputLit">{{$t('Security.Lic.voice')}}:</div>
            <input class="e-input e-input-group" v-model="voice" readonly />
          </div>
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div class="form-group">
          <div class="e-float-input">
            <div class="h-inputLit">{{$t('Security.Lic.vedio')}}:</div>
            <input class="e-input e-input-group" v-model="vedio" readonly />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../../../plugins/eventBus";
export default {
  name: "LicDetail",
  data() {
    return {
      imsFlag: false,
      sn: '',
      slice: '',
      throughPut: '',
      maxNumberOfUe: '',
      numberOfStation: '',
      caps: '',
      voice: '',
      vedio: '',
    }
  },
  methods: {
    findDevLicense(id, typeName) {
      const url = '/lte/ems/license/findLicenseInfo';
      let That = this;
      if(typeName == 'ims'){
        That.imsFlag = true;
      }else{
        That.imsFlag = false;
      }
      this.$axios.get(url, { params: { id: id }}).then(response => {
        if(!!response.data && response.data.success==0){
          That.sn = response.data.sn;
          That.slice = response.data.slice;
          That.throughPut = response.data.throughPut;
          That.maxNumberOfUe = response.data.maxNumberOfUe;
          That.numberOfStation = response.data.numberOfStation;
          That.caps = response.data.caps;
          That.voice = response.data.voice;
          That.vedio = response.data.vedio;
        }else{
          That.eventEmit('error',`${That.$t('Common.tips.failure')}`+':'+response.data.msg);
        }
      })
    },
    eventEmit(type, content) {
      EventBus.$emit('toast', {type: type, content: content})
    }
  }
}
</script>
<style scoped>
  .license_box{
    width: 70%;
    margin: 10px 15%;
  }
</style>
